<script lang="ts">
  import { t } from "svelte-i18n";

  export let messages: string[] | null | undefined = undefined;
</script>

{#if messages}
    {#each messages as message}
        {$t(message)}
    {/each}
{/if}
